import { useState, useEffect } from 'react';
import { SelectedCompany } from '@/components/company-select-bh/company-select-bh';

const DEFAULT_STORAGE_KEY = 'selectedCompany';

type UseSelectedCompanyOptions = {
  storageKey?: string;
};

export const useSelectedCompany = (options?: UseSelectedCompanyOptions) => {
  const storageKey = options?.storageKey || DEFAULT_STORAGE_KEY;

  const [selectedCompany, setSelectedCompany] = useState<SelectedCompany>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        return JSON.parse(stored) as SelectedCompany;
      }
    } catch (error) {
      console.error('Failed to parse stored company:', error);
    }
    return undefined;
  });

  useEffect(() => {
    if (selectedCompany) {
      localStorage.setItem(storageKey, JSON.stringify(selectedCompany));
    } else {
      localStorage.removeItem(storageKey);
    }
  }, [selectedCompany, storageKey]);

  return {
    selectedCompany,
    setSelectedCompany,
  };
};
